<template>
  <div class="one-data-column">
    <div
      class="one-data-column__column one-data-column__label-column"
      v-bind="labelProps"
    >
      <slot name="label" />
    </div>

    <div
      class="one-data-column__column one-data-column__data-column"
      v-bind="dataProps"
    >
      <slot />
    </div>
  </div>
</template>

<script>
  export default {
    name: 'OneDataColumn',
    props: {
      labelProps: {
        type: Object,
        default: null
      },
      dataProps: {
        type: Object,
        default: null
      }
    }
  }
</script>

<style lang="scss">
  .one-data-column {
    display: flex;
    font-size: 16px;

    &__column {
      padding: 9px 15px;
    }

    &__label-column {
      width: 230px;
    }

    &__data-column {
      flex: 1;
      min-width: 345px;
    }
  }
</style>
